import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui";

/**
 * Growth is the single CliniSharp plan (owner decision 2026-10-20), so the
 * former upgrade and downgrade pages have no plan to offer. Their routes stay
 * because the usage panel and the usage-limit dialog still link to them.
 */
export function SinglePlanNotice() {
  const navigate = useNavigate();

  return (
    <section className="mx-auto w-full max-w-2xl px-4 py-8">
      <div className="space-y-4 rounded-2xl border border-app-border bg-white p-6">
        <h1 className="text-2xl font-bold text-foreground">Plano único</h1>
        <p className="text-muted-foreground">
          A CliniSharp tem um plano único, o Growth. Não há outro plano para trocar: a Ativação e a
          Evolução contínua são combinadas com a equipe CliniSharp.
        </p>
        <Button variant="outline" onClick={() => navigate("/settings/usage")}>
          Voltar para Assinatura e uso
        </Button>
      </div>
    </section>
  );
}
